import { render, staticRenderFns } from "./CloseEventDialog.vue?vue&type=template&id=6a81cfd1"
import script from "./CloseEventDialog.vue?vue&type=script&lang=js"
export * from "./CloseEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports